import http from './http-common'

class TestBBBDataService {
    get() {
        return http.get(process.env.VUE_APP_API)
    }

    getIP() {
        return http.get(process.env.VUE_APP_API + '/ip')
    }

    getIP2(adresse) {
        return http.get(process.env.VUE_APP_API + '/ip2/' + adresse)
    }

    speedTest() {
        return http.get(process.env.VUE_APP_API + '/speedtest')
    }

    getUA() {
        return http.get(process.env.VUE_APP_API + '/ua')
    }

    postResult(res) {
        return http.post(process.env.VUE_APP_RESULT_API + '/new', res)
    }

    mailTicket(res) {
        return http.post(process.env.VUE_APP_RESULT_API + '/mail_ticket', res)
        //return http.post('https://celest-dev-u18.di.unistra.fr/api/results/mail_ticket', res)
    }
}

export default new TestBBBDataService()
